/** Layouts */
import BaseLayout from '@/views/compte/formation/formation_session/layouts/BaseLayout';

/** Components */
import Show from '@/views/compte/formation/formation_session/components/Show';
import Document from '@/views/fichier/pages/FichierList';

export default [
  {
    path: '/compte/formation/formation-session',
    component: BaseLayout,
    children: [
      {
        path: 'show/:sessionId',
        component: Show,
        name: 'compte_formation_show_session-show',
        meta: {
          auth: true,
          module: 'compte',
          permission: 'access setting',
        },
      },
      {
        path: 'document/:sessionId/:documentUuid',
        component: Document,
        name: 'compte_formation_show_session-document',
        meta: {
          auth: true,
          module: 'compte',
          permission: 'access setting',
        },
      },
    ],
  },
];
